<template>
  <div class="card rounded-3 bg-transparent shadow">
        <div class="card-header bg-warning bg-gradient">
          <h5 class="card-title text-center">Category</h5>
        </div>
        <!-- Kanban Body -->
            <div
            class="card rounded-3 shadow mb-3"
                >
            <div class="card-header p-2">
              <h5 class="card-title fs-6 mb-0">{{task.title}}</h5>
            </div>
            <div class="card-body p-2">
              <p
                style="
                  background-color: rgba(49, 49, 49, 0.377);
                  border-radius: 10%;
                  display: inline;
                  padding: 3px;
                "
              >
              {{task.User.username}}
              </p>
              <div class="d-flex justify-content-end">
                <button
                  type="button"
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                  class="m-1 btn btn-outline-warning"
                  @click.prevent="fetchDetail(task.id)"
                >
                  Edit
                  <i class="fas fa-edit"></i>
                </button>
                <button
                  class="m-1 btn btn-outline-danger"
                  @click.prevent="deleteData(task.id)"
                >
                  Delete
                  <i class="far fa-trash-alt"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
</template>

<script>
export default {
    name: "Item",
    props: ["task"],
    methods: {
    deleteData(id) {
      console.log(id, "<<<id Card");
      this.$emit("deleteData", id);
    },
    fetchDetail(id) {
      this.$emit("fetchDetail", id);
    },
    }
}
</script>

<style>

</style>